import styled from "styled-components";

export const RightContent = styled.div`
    position: sticky;
    grid-area: right;
    padding-left: 20px;
    padding-top: 52px;
    z-index: 10;
    background-color: #f9f1dd;
    @media (max-width: 1200px) {
        padding-top: 30px;
        padding-left: 0;
    }
`;

export const StickyWrapper = styled.div`
    position: sticky;
    top: 100px;
`;

export const RelatedArticles = styled.div`
    display: grid;
    grid-auto-flow: row;
    @media (max-width: 1240px) {
        display: none;
    }
`;

export const RelatedArticleHeader = styled.div`
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    line-height: 35px;
    color: rgba(0, 0, 0, 0.85);
    padding-bottom: 25px;
`;

export const RelatedArticleList = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-gap: 10px;
`;

export const RelatedArticleItem = styled.div`
    padding: 20px;
    border-radius: 20px;
    background: #ffffff;
    display: flex;
    justify-content: space-around;
    cursor: pointer;
    &:after {
        content: "";
        width: 0;
        display: block;
        height: 0;
        border-top: 12px solid transparent;
        border-bottom: 12px solid transparent;
        border-left: 12px solid #edd2b1;
        margin-left: 10px;
    }
`;

export const RelatedArticleText = styled.p`
    margin: unset;
    white-space: nowrap;
    margin-top: 0.25em;
`;

export const Share = styled.div`
    display: grid;
    padding-top: 32px;
    grid-auto-flow: row;
    @media (max-width: 1240px) {
        padding-top: 0;
        justify-content: center;
    }
`;

export const ShareHeader = styled.div`
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    line-height: 35px;
    @media (max-width: 1240px) {
        margin: auto;
    }
`;

export const ShareSocialList = styled.div`
    padding-top: 20px;
    display: grid;
    grid-auto-flow: column;
    grid-gap: 42px;
    justify-content: flex-start;
    a {
        display: block;
        position: relative;
        cursor: pointer;
        background-size: 32px 32px;
        background-repeat: no-repeat !important;
        width: 60px;
        height: 60px;
        background-position: center;
        &:before {
            content: "";
            display: block;
            position: absolute;
            z-index: -1;
            background: #efd2af;
            border-radius: 50px;
            width: 60px;
            height: 60px;
        }
    }
`;

export const Facebook = styled.a`
    background-image: url(/articles/facebook.svg);
`;

export const LinkedIn = styled.a`
    background-image: url(/articles/linkedin.svg);
`;

export const Telegram = styled.a`
    background-image: url(/articles/telegram.svg);
`;
